var React = require('react');

function ArrowNE (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.767578 9.24707L1.91016 10.3896L9.16992 3.12988L9.17871 8.28906L10.7432 8.29785V0.387695L2.85059 0.414062L2.86816 1.97852L8.04492 1.96973L0.767578 9.24707Z","fill":"white"}));
}

ArrowNE.defaultProps = {"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none"};

module.exports = ArrowNE;

ArrowNE.default = ArrowNE;
